<button
  matTooltipPosition="after"
  type="button"
  mat-dialog-close
  class="flex items-center justify-center text-white bg-white hover:bg-opacity-75 rounded-full w-10 h-10 ring-4 ring-kimbo-turquoise ring-opacity-25 focus:ring-kimbo-turquoise-blue focus:ring-opacity-25 focus:outline-none absolute top-6 right-5 z-mobile-bar-backdrop"
>
  <img appImg src="assets/svg/close.svg" alt="close icon" class="text-white w-6 h-6" />
  <span class="sr-only">Open actions menu</span>
</button>

<div
  (click)="closeDialog()"
  class="w-full mx-auto {{ bpReached ? 'mt-6' : 'my-6' }}  relative cursor-pointer"
>
  <div class="flex flex-wrap w-full">
    <div
      *ngFor="let slide of slides; let i = index"
      class="w-full sm:w-1/2-with-gap flex flex-col relative justify-center items-center mb-6 sm:mb-0"
    >
      <span
        class="absolute z-base text-7xl sm:text-8xl text-kimbo-turquoise top-0  {{
          bpReached ? 'right-12' : 'left-5'
        }}  font-bold"
        >{{ i + 1 }}</span
      >
      <div class="w-full md:w-9/12 flex flex-col justify-center items-center relative z-[4]">
        <img
          [src]="slide.mainImage"
          alt="carrousel items {{ i }}"
          class="w-full aspect-auto"
          loading="lazy"
        />
        <div
          class="flex flex-col items-center bg-light-gray font-poppins text-black w-4/5 p-4 mt-[-3.75rem] whitespace-normal text-center gap-y-2"
        >
          <div
            class="w-14 h-14 flex justify-center items-center rounded-full bg-kimbo-turquoise mt-[-40px]"
          >
            <img
              [src]="slide.icon"
              alt="carrousel items icons {{ i }}"
              style="width: 30px !important"
              class="w-6 aspect-auto"
              loading="lazy"
            />
          </div>
          <div class="font-black text-base leading-6 flex-1 flex-shrink">{{ slide.title }}</div>
          <div class="text-base leading-6">{{ slide.description }}</div>
          <div class="flex justify-center gap-x-4"></div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="flex justify-center my-4 fixed z-mobile-bar-backdrop left-0 right-0 {{
      !bpReached ? 'bottom-6' : 'bottom-[70px]'
    }}"
  >
    <a
      (click)="closeDialog()"
      style="box-shadow: rgba(0, 168, 147, 0.36) 0rem 0.625rem 1.875rem"
      class="w-fit flex gap-2 px-11 text-lg text-center tracking-wider h-14 justify-center items-center bg-transparent rounded-full font-semibold bg-kimbo-gradient bg-no-repeat bg-origin-padding bg-clip-padding text-white cursor-pointer"
    >
      <span>{{ getStartedButtonLabel }}</span>
      <mat-icon>arrow_forward</mat-icon>
    </a>
  </div>
</div>
